import { render, staticRenderFns } from "./EventAddSuccess.vue?vue&type=template&id=aea7cea8&"
import script from "./EventAddSuccess.vue?vue&type=script&lang=js&"
export * from "./EventAddSuccess.vue?vue&type=script&lang=js&"
import style0 from "./EventAddSuccess.vue?vue&type=style&index=0&id=aea7cea8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports